import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import {
  ApprovalStatus,
  useGetAssetCountByIdQuery,
  useGetUsersByAccountAndSoftwareQuery,
  UserSelection,
} from 'generated/graphql'
import { useColorStatusList } from 'helpers/Hooks/useColorStatusList'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import React, { useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router'
import { AssetsCountDetailContent } from './AssetsCountDetailContent'
import { AssetsCountDetailitemContent } from './AssetsCountDetaiItemContent'

export const AssetsCountDetail = (props: any) => {
  const history = useHistory()
  const { mode } = props
  const { CompanyID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const location = useLocation()
  const editData = location?.state as any
  const { handleStatusColor } = useColorStatusList()
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */

  const {
    loading: assetCountLoading,
    data: { getAssetCountById } = { getAssetCountById: null },
  } = useGetAssetCountByIdQuery({
    fetchPolicy: 'network-only',
    skip: !editData?.asset_count_id,
    variables: { asset_count_id: editData?.asset_count_id },
    onError: ({ message }) => {
      const error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: getUsersByAccountAndSoftwareLoading,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({
    fetchPolicy: 'network-only',
    variables: {
      superUserBool: UserSelection.All,
    },
  })

  const countData = getAssetCountById || editData

  const countDetails = countData?.CountDetails || []
  const totalItems = countDetails.length
  const discrepancies = countDetails.filter(
    d => Number(d.counted_qty) !== Number(d.asset_qty)
  ).length

  const RecordStatusText = (pStatus: ApprovalStatus) => {
    switch (pStatus) {
      case ApprovalStatus.Submit:
        return 'Submitted'
      case ApprovalStatus.Active:
        return 'Draft'
      case ApprovalStatus.Approved:
        return 'Submitted'
      case ApprovalStatus.Completed:
        return 'Approved'
      case ApprovalStatus.Rejected:
        return 'Rejected'
      case ApprovalStatus.Cancelled:
        return 'Cancelled'
      default:
        return ''
    }
  }

  return (
    <>
      {assetCountLoading && <Loading />}
      {getUsersByAccountAndSoftwareLoading && <Loading />}

      <MainHeader
        mainBtn="back"
        onClick={() => {
          if (mode === 'workdesk') {
            history.push('/workdesk/fixed-assets')
          } else if (mode === 'workdesk-history') {
            history.push('/workdesk-history/fixed-assets')
          } else {
            history.push(`/fixed-assets/${CompanyID}/assets-count`)
          }
        }}
        smTitle="Fixed Assets"
        title={user?.companyName}
        routeSegments={[
          { name: 'Fixed Assets' },
          { name: 'Assets Count' },
          { name: 'Detail', current: true },
        ]}
      />

      <DynamicSubHeader
        title={
          <span className="c-orange">
            <span style={{ fontWeight: 'bold' }}>
              {countData?.DocNo || 'Draft'}
            </span>
          </span>
        }
        rightText={
          <span
            className="xxs title"
            style={{
              color: handleStatusColor(countData?.ApprovalStatus),
            }}
          >
            {RecordStatusText(countData?.ApprovalStatus)}
          </span>
        }
        infoLine={
          <>
            <div className="desc">{countData?.Category?.name}</div>
          </>
        }
        rightInfoLine={
          <span className="desc">{formatDate(countData?.count_date)}</span>
        }
      />

      <ContentWrapper multiDynamicInfo float>
        <CardContents>
          <AssetsCountDetailContent
            listEl={countData}
            listStatus={countData?.ApprovalStatus}
            userList={getUsersByAccountAndSoftware}
            mode={'detail'}
          />
        </CardContents>

        <CardContents
          section={{
            header: {
              title: `Count Items (${totalItems})`,
            },
          }}
        >
          <AssetsCountDetailitemContent listItem={countDetails} />
        </CardContents>
      </ContentWrapper>

      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error'}
      />
    </>
  )
}
